import { de, enGB as en, es, fr, it } from 'date-fns/locale';

export const locales = {
    en,
    fr,
    es,
    de,
    it,
};

type AnyString = {} & string;

export function getLocale(
    locale: keyof typeof locales | AnyString
): (typeof locales)[keyof typeof locales] | undefined {
    return locales[locale];
}
